export const costCategories = {
  validation: { label: "Validação", description: "" },
  monitoring: {
    label: "Monitoramento",
    description: "Custos anuais de monitoramento contínuo do projeto",
  },
  verification: {
    label: "Verificação",
    description: "Custos periódicos de verificação",
  },
  issuance: {
    label: "Emissão",
    description: "Custos associados à emissão de créditos",
  },
  community: {
    label: "Atividades comunitárias adicionais",
    description:
      "Engajamento comunitário opcional, CLPI, salvaguardas e outras atividades que não são pagamentos diretos",
  },
};

export const costItems = {
  activity_community_patrols: "Patrulhas comunitárias",
  activity_satellite_monitoring: "Monitoramento por satélite",
  activity_reforestation_site_prep: "Preparo da área para reflorestamento",
  activity_reforestation_planting: "Plantio de reflorestamento",
  activity_reforestation_nursery: "Viveiro de reflorestamento",
  activity_reforestation_maintenance: "Manutenção do reflorestamento",
  activity_firebreak_site_prep: "Aceiro / preparo da área",
  vvb_validation: "Validação por VVB",
  vvb_verification: "Verificação por VVB",
  remote_sensing: "Sensoriamento remoto",
  mrv_report_prep: "Preparação do relatório de MRV",
  field_ops: "Operações de campo",
  field_travel: "Deslocamento de campo",
  plot_establishment: "Instalação de parcelas",
  plot_remeasurement: "Remedição de parcelas",
  tree_measurement: "Medição de árvores",
  legal_admin: "Jurídico e administrativo",
  community_engagement: "Engajamento comunitário / implementação do CLPI",
  buffer_withholding: "Retenção de buffer",
  working_capital_carry: "Carregamento de capital de giro",
  redd_vvb_validation: "Validação REDD+ por VVB",
  redd_vvb_verification: "Verificação REDD+ por VVB",
  arr_vvb_validation: "Validação ARR por VVB",
  arr_vvb_verification: "Verificação ARR por VVB",
  preliminary_ghg_quantification: "Quantificação preliminar de GEE",
  certification_fee_under_10k_ha: "Taxa de certificação até 10.000 ha",
  certification_fee_10k_to_100k_ha: "Taxa de certificação de 10.000 a 100.000 ha",
  certification_fee_over_100k_ha: "Taxa de certificação acima de 100.000 ha",
  validation_vvb_fee: "Taxa de validação por VVB",
  mrv_tiered: "Taxa de MRV",
  verification_vvb_fee: "Taxa de verificação por VVB",
  project_expansion_fee: "Taxa de expansão do projeto",
  preliminary_ghg_baseline_assessment: "Avaliação preliminar da linha de base de GEE",
  feasibility_assessment: "Avaliação de viabilidade",
  design_review: "Revisão do desenho do projeto",
  plan_vivo_pin_fee: "Taxa PIN da Plan Vivo",
  plan_vivo_pdd_fee_macro: "Taxa PDD da Plan Vivo",
  acceptance_criteria_validation_base:
    "Base de validação dos critérios de aceitação",
  acceptance_criteria_validation_per_property:
    "Validação dos critérios de aceitação por propriedade",
  acceptance_criteria_verification_base:
    "Base de verificação dos critérios de aceitação",
  acceptance_criteria_verification_per_property:
    "Verificação dos critérios de aceitação por propriedade",
  account_annual: "Taxa anual da conta",
  account_open: "Taxa de abertura de conta",
  account_registration: "Registro de conta",
  activation_fee: "Taxa de ativação",
  art_registry_account_annual: "Taxa anual da conta no registro ART",
  art_trees_issuance_fee: "Taxa de emissão ART TREES",
  baseline_study: "Estudo de linha de base",
  baseline_study_core: "Núcleo do estudo de linha de base",
  benefit_admin: "Administração de benefícios",
  custodial_annual: "Taxa anual de custódia",
  data_platform: "Plataforma de dados",
  data_processing: "Processamento de dados",
  drone_capex: "Equipamento de drone",
  drone_depreciation: "Depreciação do drone",
  equitable_earth_design_review_base:
    "Base da revisão de desenho da Equitable Earth",
  equitable_earth_design_review_per_ha:
    "Revisão de desenho da Equitable Earth por ha",
  equitable_earth_design_review_per_ha_raw:
    "Revisão de desenho da Equitable Earth por ha",
  equitable_earth_feasibility_review_base:
    "Base da revisão de viabilidade da Equitable Earth",
  equitable_earth_feasibility_review_per_ha:
    "Revisão de viabilidade da Equitable Earth por ha",
  equitable_earth_feasibility_review_per_ha_raw:
    "Revisão de viabilidade da Equitable Earth por ha",
  equitable_earth_monitoring_reporting_base_annual:
    "Base anual de monitoramento e relatório da Equitable Earth",
  equitable_earth_monitoring_reporting_per_ha_annual:
    "Monitoramento e relatório anual da Equitable Earth por ha",
  equitable_earth_preliminary_ghg_assessment:
    "Avaliação preliminar de GEE da Equitable Earth",
  extension_support: "Suporte de extensão",
  farmer_enrollment: "Cadastro de agricultores",
  fpic_consultation: "Consulta de CLPI",
  gcc_issuance_fee: "Taxa de emissão GCC",
  gcc_project_registration: "Registro de projeto GCC",
  gcc_transaction_registry_account_open:
    "Abertura de conta no registro de transações GCC",
  gcc_transaction_registry_annual:
    "Taxa anual do registro de transações GCC",
  insurance: "Seguro",
  inventory_completion: "Conclusão do inventário",
  inventory_completion_core: "Núcleo da conclusão do inventário",
  inventory_core: "Núcleo do inventário",
  issuance_fee_sop_cash: "Taxa de emissão SOP em dinheiro",
  lca_modeling: "Modelagem de ACV",
  leakage_analysis: "Análise de vazamento",
  listing_review: "Revisão de listagem",
  metering_pack: "Pacote de medição",
  monitoring_drone: "Drone de monitoramento",
  nursery_opex: "Operação de viveiro",
  output_audit: "Auditoria de resultado",
  pada_fee: "Taxa PADA",
  pada_linear: "Taxa PADA por hectare",
  parcel_mapping: "Mapeamento de parcelas",
  per_credit_monitoring: "Monitoramento por crédito",
  performance_review: "Revisão de desempenho",
  pipeline_listing: "Listagem no pipeline",
  planting: "Plantio",
  pooling_fee: "Taxa de agregação",
  preliminary_review: "Revisão preliminar",
  registration_review: "Revisão de registro",
  registry_annual: "Taxa anual de registro",
  requantification_transition: "Transição de requantificação",
  retirement_fee: "Taxa de aposentadoria",
  royalty_fee: "Taxa de royalties",
  sampling: "Amostragem",
  sensor_calibration: "Calibração de sensores",
  sensor_capex: "Equipamento de sensores",
  sensor_depreciation: "Depreciação de sensores",
  sensor_package: "Pacote de sensores",
  share_of_proceeds: "Participação nas receitas",
  site_maintenance: "Manutenção da área",
  site_prep: "Preparo da área",
  social_carbon_issuance_fee: "Taxa de emissão SOCIALCARBON",
  social_carbon_project_design_review:
    "Revisão de desenho do projeto SOCIALCARBON",
  social_carbon_registration_review: "Revisão de registro SOCIALCARBON",
  stock_change_review: "Revisão de mudança de estoque",
  survival_sampling: "Amostragem de sobrevivência",
  validation_review: "Revisão de validação",
  vcu_issuance_levy: "Taxa de emissão de VCU",
  verification_fee_base: "Base da taxa de verificação",
  verification_fee_per_site: "Taxa de verificação por local",
  verification_review: "Revisão de verificação",
};

export const costItemNotes = {
  redd_vvb_validation:
    "A estimativa usa faixas de mercado [V3][V4]; o valor final requer cotação de VVB.",
  redd_vvb_verification:
    "A estimativa usa faixas de mercado [V3][V4]; o valor final requer cotação de VVB.",
  arr_vvb_validation:
    "A estimativa usa faixas de mercado [V3][V4]; o valor final requer cotação de VVB.",
  arr_vvb_verification:
    "A estimativa usa faixas de mercado [V3][V4]; o valor final requer cotação de VVB.",
  preliminary_ghg_quantification:
    "Pago após o recebimento da quantificação preliminar do potencial de GEE.",
  certification_fee_under_10k_ha: "Projetos abaixo de 10.000 ha.",
  certification_fee_10k_to_100k_ha: "Projetos de 10.000 ha a 100.000 ha.",
  certification_fee_over_100k_ha: "Projetos acima de 100.000 ha.",
  validation_vvb_fee:
    "Pago pela Equitable Earth e recobrado do desenvolvedor na assinatura do contrato.",
  mrv_tiered: "Pago todos os anos no início do ano.",
  verification_vvb_fee: "Recobrado a cada auditoria de verificação.",
  project_expansion_fee: "Por expansão fora do período de gestão adaptativa.",
  preliminary_ghg_baseline_assessment: "Sequência do grupo 2.",
  feasibility_assessment: "Sequência do grupo 2.",
  design_review: "Sequência do grupo 2.",
};
